module.exports = __webpack_public_path__ + "static/img/radar.9846869.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/radar.png
// module id = Jg4l
// module chunks = 1